/* eslint-disable */
import { Video, VideoPDF } from "./models/Video";
import VideoEvents from "./VideoEvents";
import { VideoReaction } from "./models/VideoReaction";
import { AppAction } from "../../root/AppAction";
import { Tag } from "./models/VideoFilter";
import ExVideoEvents from "../../store/events/ExVideoEvents";
import { VideoCaption } from "../../models/video";

export interface VideoStore {
  list: number[];
  videos: { [id: number]: Video };
  tags: Tag[];
  isLoading: boolean;
  isUploading: boolean;
  isSendVideo: boolean;
  isSuccessSendVideo: boolean;
  isFailedSendVideo: boolean;
  isEditVideo: boolean;
  isSuccessEditVideo: boolean;
  isFailedEditVideo: boolean;
  isDeleteVideo: boolean;
  isUploadDocument: boolean;
  isSuccessUploadDocument: boolean;
  isFailedUploadDocument: boolean;
  isSuccessDeleteVideo: boolean;
  isFailedDeleteVideo: boolean;
  video: Video | undefined;
  isResetVideo: boolean;
  isResetVideos: boolean;
  videoPdf: VideoPDF | undefined;
  isUpdateVideoSlide: boolean;
  isSuccessUpdateVideoSlide: boolean;
  isFailedUpdateVideoSlide: boolean;
  isDeleteVideoSlide: boolean;
  isSuccessDeleteVideoSlide: boolean;
  isFailedDeleteVideoSlide: boolean;
  visibleLoading: boolean;
  failedVideoTitle: string;
  currentVideoCaptions: VideoCaption[],
}

const initialStore: VideoStore = {
  list: [],
  videos: {},
  tags: [],
  isLoading: true,
  isUploading: false,
  isSendVideo: false,
  isSuccessSendVideo: false,
  isFailedSendVideo: false,
  isEditVideo: false,
  isSuccessEditVideo: false,
  isUploadDocument: false,
  isFailedEditVideo: false,
  isSuccessUploadDocument: false,
  isFailedUploadDocument: false,
  isDeleteVideo: false,
  isSuccessDeleteVideo: false,
  isFailedDeleteVideo: false,
  video: undefined,
  isResetVideo: true,
  isResetVideos: true,
  videoPdf: undefined,
  isUpdateVideoSlide: false,
  isSuccessUpdateVideoSlide: false,
  isFailedUpdateVideoSlide: false,
  isDeleteVideoSlide: false,
  isSuccessDeleteVideoSlide: false,
  isFailedDeleteVideoSlide: false,
  visibleLoading: false,
  failedVideoTitle: "",
  currentVideoCaptions: [],
};

/**
 * 字幕store
 */
export interface SubtitlesStore {
  currentLanguage: string,
  captions: VideoCaption[]
}

/**
 * 字幕store初期化
 */
const initialSubtitlesStore: SubtitlesStore = {
  currentLanguage: "", 
  captions: []
};

function byIdMap(videos: Video[]): { [id: number]: Video } {
  // videosの配列をidをキーにしたオブジェクトに変換
  console.log("byIdMap", videos);
  //   console.log("Video", Video);
  console.log(Object.fromEntries(videos.map((video) => [video.id, video])));

  return Object.fromEntries(videos.map((video) => [video.id, video]));
}

function UpdateCaption(defaultCaption: any, updateCaption: VideoCaption) {
  if (defaultCaption) {
    const newCaptionList = defaultCaption.map(caption => 
      caption.id === updateCaption.id ? { ...caption, transcript: updateCaption.transcript } : caption
    );
    return newCaptionList;
  }
}

export default function video(
  state: VideoStore = initialStore,
  action: AppAction
) {
  switch (action.type) {
    case VideoEvents.LoadVideoListStarted:
      return {
        ...state,
        isLoading: true,
      };

    case VideoEvents.LoadVideoListComplete:
      return {
        ...state,
        isLoading: false,
        videos: byIdMap(action.videos),
        list: action.videos.map(({ id }: Video) => id),
        isResetVideos: false,
      };

    case VideoEvents.LoadVideoStarted:
      return { ...state, isLoading: true };

    case VideoEvents.LoadVideoComplete:
      return {
        ...state,
        videos: {
          ...state.videos,
          [action.video.id]: action.video,
        },
        video: action.video,
        list: [...state.list, action.video.id],
        isLoading: false,
        isResetVideo: false,
      };

    case VideoEvents.CreateStarted:
      return {
        ...state,
        isUploading: true,
      };

    case VideoEvents.CreateComplete:
      return {
        ...state,
        isUploading: false,
      };

    case VideoEvents.IncrementViewCount:
      return {
        ...state,
        videos: {
          ...state.videos,
          [action.videoId]: {
            ...state.videos[action.videoId],
            viewCount: state.videos[action.videoId].viewCount + 1,
          },
        },
      };

    case VideoEvents.Update:
      return {
        ...state,
        videos: {
          ...state.videos,
          [action.videoId]: {
            ...state.videos[action.videoId],
            ...action.changeSet,
          },
        },
      };

    case VideoEvents.CommentComplete:
      const newVideo ={
        ...state.video,
        comments: [
          action.comment,
          ...state.video.comments,
        ],
      }
      return {
        ...state,
        videos: {
          ...state.videos,
          [action.comment.videoId]: newVideo,
        },
        video: newVideo,
      };

    case VideoEvents.ReactComplete:
      return {
        ...state,
        videos: {
          ...state.videos,
          [action.reaction.videoId]: {
            ...state.videos[action.reaction.videoId],
            reactions: [
              ...state.videos[action.reaction.videoId].reactions,
              action.reaction,
            ].sort(reactionTimeComparator),
          },
        },
      };

    case VideoEvents.Delete:
      return {
        ...state,
        videos: Object.fromEntries(
          Object.entries(state.videos).filter(
            ([_, { id }]) => id !== action.videoId
          )
        ),
        list: state.list.filter((id) => id !== action.videoId),
      };

    case VideoEvents.UploadExtraMaterialsComplete:
      return {
        ...state,
        videos: {
          ...state.videos,
          [action.material.videoId]: {
            ...state.videos[action.material.videoId],
            extraMaterials: [
              ...state.videos[action.material.videoId].extraMaterials,
              action.material,
            ],
          },
        },
      };

    case VideoEvents.DeleteExtraMaterials:
      return {
        ...state,
        videos: {
          ...state.videos,
          [action.videoId]: {
            ...state.videos[action.videoId],
            extraMaterials: state.videos[action.videoId].extraMaterials.filter(
              ({ id }) => id !== action.materialId
            ),
          },
        },
      };

    case VideoEvents.filterVideoListStarted:
      return {
        ...state,
        isLoading: true,
      };

    case VideoEvents.filterVideoListComplete:
      return {
        ...state,
        isLoading: false,
        videos: byIdMap(action.filterResult.videos),
        list: action.filterResult.videos.map(({ id }: Video) => id),
        tags: action.filterResult.tags,
        isResetVideos: false,
      };

    case VideoEvents.getTagListStarted:
      return {
        ...state,
      };

    case VideoEvents.getTagListComplete:
      return {
        ...state,
        tags: action.tagOutput,
      };

    // ビデオ追加
    case VideoEvents.AddVideoStarted:
      console.log("AddVideoStarted");
      return {
        ...state,
        isSendVideo: true,
        isSuccessSendVideo: false,
        isFailedSendVideo: false,
      };

    case VideoEvents.AddVideoComplete:
      console.log("AddVideoComplete");
      return {
        ...state,
        isSendVideo: false,
        isSuccessSendVideo: true,
        isFailedSendVideo: false,
      };

    case VideoEvents.AddVideoFailed:
      console.log("AddVideoFailed");
      return {
        ...state,
        isSendVideo: false,
        isSuccessSendVideo: false,
        isFailedSendVideo: true,
      };

    // ビデオ編集
    case VideoEvents.EditVideoStarted:
      console.log("EditVideoStarted");
      return {
        ...state,
        isLoading: true,
        isEditVideo: true,
        isSuccessEditVideo: false,
        isFailedEditVideo: false,
        failedVideoTitle: "",
      };

    case VideoEvents.EditVideoComplete:
      console.log("EditVideoComplete");
      return {
        ...state,
        videos: {
          ...state.videos,
          [action.updateVideo.id]: action.updateVideo,
        },
        isLoading: false,
        isEditVideo: false,
        isSuccessEditVideo: true,
        isFailedEditVideo: false,
      };
    case VideoEvents.EditVideoFailed:
      console.log("EditVideoFailed");
      return {
        ...state,
        isLoading: false,
        isEditVideo: false,
        isSuccessEditVideo: false,
        isFailedEditVideo: true,
        failedVideoTitle: state.videos[action.videoId].title,
      };

    // ビデオ資料アップロード
    case VideoEvents.UploadDocumentStarted:
      console.log("UploadDocumentStarted");
      return {
        ...state,
        isLoading: true,
        isUploadDocument: true,
        isSuccessEditVideo: false,
        isFailedEditVideo: false,
      };

    case VideoEvents.UploadDocumentComplete:
      console.log("UploadDocumentComplete");
      return {
        ...state,
        isLoading: false,
        isUploadDocument: false,
        isSuccessUploadDocument: true,
        videos: {
          ...state.videos,
          [action.document.videoId]: {
            ...state.videos[action.document.videoId],
            extraMaterials: action.document,
          },
        },
      };
    case VideoEvents.UploadDocumentFailed:
      console.log("UploadDocumentFailed");
      return {
        ...state,
        isLoading: false,
        isUploadDocument: false,
        isFailedUploadDocument: true,
      };

    // ビデオ削除
    case VideoEvents.DeleteVideoStarted:
      console.log("DeleteVideoStarted");
      return {
        ...state,
        isLoading: true,
        isDeleteVideo: true,
        isSuccessDeleteVideo: false,
        isFailedDeleteVideo: false,
      };

    case VideoEvents.DeleteVideoComplete:
      console.log("DeleteVideoComplete");
      return {
        ...state,
        isLoading: false,
        isDeleteVideo: false,
        isSuccessDeleteVideo: true,
        isFailedDeleteVideo: false,
      };

    case VideoEvents.DeleteVideoFailed:
      console.log("DeleteVideoFalied");
      return {
        ...state,
        isLoading: false,
        isDeleteVideo: false,
        isSuccessDeleteVideo: false,
        isFailedDeleteVideo: true,
      };

    // STT修正でvideoストア更新
    case ExVideoEvents.EditVideoCaptionComplete: {
      console.log("EditVideoCaptionComplete");
      const newCaptions = UpdateCaption(state.currentVideoCaptions, action.updateCaption);
      return {
        ...state,
        currentVideoCaptions: newCaptions,
        video: {
          ...state.video,
          captions: newCaptions,
        },
      };
    }

    // STTの公開ステータス変更でvideoストア更新
    case ExVideoEvents.UpdateCaptionPublicStateComplete:
      return {
        ...state,
        video: {
          ...state.video,
          publicCaption: !state.video?.publicCaption,
        },
      };

    // ビデオデータリセット
    case VideoEvents.ResetVideos:
      return {
        ...state,
        list: [],
        videos: {},
        isLoading: true,
        isResetVideos: true,
      };
    case VideoEvents.ResetVideo:
      return {
        ...state,
        isResetVideo: true,
        isLoading: false,
        video: undefined,
      };

    // ビデオスライド資料取得
    case VideoEvents.GetVideoSlide:
      return {
        ...state,
      };

    case VideoEvents.GetVideoSlideComplete:
      return {
        ...state,
        videoPdf: action.videoPdf,
      };

    // ビデオスライド資料追加
    case VideoEvents.UploadVideoSlideComplete:
      return {
        ...state,
        videoPdf: action.videoSlide,
      };

    // ビデオスライド資料編集
    case VideoEvents.EditVideoSlideStarted:
      return {
        ...state,
        isUpdateVideoSlide: true,
        isSuccessUpdateVideoSlide: false,
        isFailedUpdateVideoSlide: false,
      };

    case VideoEvents.EditVideoSlideFailed:
      return {
        ...state,
        isUpdateVideoSlide: false,
        isFailedUpdateVideoSlide: true,
        // isLoading: true
      };

    case VideoEvents.EditVideoSlideComplete:
      return {
        ...state,
        videoPdf: action.videoSlide,
        videos: {
          ...state.videos,
          [action.videoId]: {
            ...state.videos[action.videoId],
            slideFlg: action.videoSlide.isPublic,
            videoSlides: action.videoSlide.videoSlides,
          },
        },
        isUpdateVideoSlide: false,
        isSuccessUpdateVideoSlide: true,
      };

    // ビデオスライド資料削除
    case VideoEvents.DeleteVideoSlideStarted:
      return {
        ...state,
        isDeleteVideoSlide: true,
        isSuccessDeleteVideoSlide: false,
        isFailedDeleteVideoSlide: false,
      };

    case VideoEvents.DeleteVideoSlideFailed:
      return {
        ...state,
        isDeleteVideoSlide: false,
        isFailedDeleteVideoSlide: true,
      };

    case VideoEvents.DeleteVideoSlideComplete:
      return {
        ...state,
        videoPdf: undefined,
        videos: {
          ...state.videos,
          [action.videoId]: {
            ...state.videos[action.videoId],
            slideFlg: false,
            videoSlides: undefined,
          },
        },
        isDeleteVideoSlide: false,
        isSuccessDeleteVideoSlide: true,
      };

    // ローディング表示
    case VideoEvents.VisibleLoading:
      console.log("VisibleLoading");
      return {
        ...state,
        visibleLoading: true,
      };

    case VideoEvents.InvisibleLoading:
      console.log("InvisibleLoading");
      return {
        ...state,
        visibleLoading: false,
      };

    case VideoEvents.SetCurrentVideoCaptions:
      console.log("SetCurrentVideoCaptions");
      return {
        ...state,
        currentVideoCaptions: action.captions,
      };

    default:
      return state;
  }
}

/**
 * 字幕Reducer定義
 * @param state 状態
 * @param action アクション
 * @returns 字幕Reducer処理
 */
export function subtitle(state = initialSubtitlesStore, action) {
   switch (action.type) {
    case VideoEvents.GetVideoCurrentSubtitleStarted:
      return {
        ...state,
        videoId: action.videoId,
        language: action.language,
        loading: true,
        error: null
      };

    case VideoEvents.GetVideoCurrentSubtitleComplete:
      return {
        ...state,
        currentLanguage: action.language,
        captions: action.captions,
        loading: false,
        error: null
      };
    default:
      return state;
  }
};

function reactionTimeComparator(r1: VideoReaction, r2: VideoReaction) {
  return r1.reactionTimeMillis - r2.reactionTimeMillis;
}
